import string from './string'

function filterData(item, queryText, itemText) {
  const maiusculoESemAcento = string.removerAcentos(queryText).toUpperCase()
  const itemCerto = item.text.includes(maiusculoESemAcento)
  return itemCerto ? item : {}
}

export default {
  filterData
}
